import Swiper from "swiper";
import { A11y, Autoplay, EffectFade, Pagination } from "swiper/modules";
import "./testimonials.css";

document.querySelectorAll(".element-testimonials.as-slider").forEach((el) => {
  const container = el.querySelector(".swiper");
  const numSlides = container.querySelectorAll(".swiper-slide").length;

  const swiper = new Swiper(container, {
    modules: [A11y, Autoplay],
    slidesPerView: 1,
    autoplay: {
      delay: 4000,
      pauseOnMouseEnter: true,
    },
    speed: 1200,
    spaceBetween: 24,
    slideToClickedSlide: true,
    centeredSlides: numSlides >= 2,
    breakpoints: {
      768: {
        centerInsufficientSlides: numSlides != 2,
        slidesPerView: 1.6,
        spaceBetween: 24,
      },
      1024: {
        centerInsufficientSlides: numSlides != 2,
        slidesPerView: 2,
        spaceBetween: 24,
      },
      1280: {
        centerInsufficientSlides: numSlides != 2,
        slidesPerView: 2.4,
        spaceBetween: 24,
      },
      1480: {
        centerInsufficientSlides: numSlides != 2,
        slidesPerView: 2.6,
        spaceBetween: 24,
      },
    },
  });

  swiper.autoplay.stop();

  const observer = new IntersectionObserver(
    ([e]) => {
      if (e.isIntersecting) {
        swiper.autoplay.start();
        observer.disconnect();
      }
    },
    {
      threshold: [0.7],
    },
  );

  observer.observe(el);
});

document.querySelectorAll(".element-testimonials.as-large").forEach((el) => {
  const container = el.querySelector(".swiper");
  const numSlides = container.querySelectorAll(".swiper-slide").length;

  const swiper = new Swiper(container, {
    modules: [A11y, Autoplay, EffectFade, Pagination],
    slidesPerView: 1,
    autoplay: {
      delay: 4000,
      pauseOnMouseEnter: true,
    },
    effect: "fade",
    loop: numSlides > 1,
    fadeEffect: {
      crossFade: true,
    },
    speed: 1200,
    pagination: {
      el: el.querySelector(".slider-pagination"),
      clickable: true,
    },
  });

  swiper.autoplay.stop();

  const observer = new IntersectionObserver(
    ([e]) => {
      if (e.isIntersecting) {
        swiper.autoplay.start();
        observer.disconnect();
      }
    },
    {
      threshold: [0.7],
    },
  );

  observer.observe(el);
});
